import { render, staticRenderFns } from "./VatTemplate.vue?vue&type=template&id=f6a74e80&scoped=true&"
import script from "./VatTemplate.vue?vue&type=script&lang=js&"
export * from "./VatTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a74e80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6a74e80')) {
      api.createRecord('f6a74e80', component.options)
    } else {
      api.reload('f6a74e80', component.options)
    }
    module.hot.accept("./VatTemplate.vue?vue&type=template&id=f6a74e80&scoped=true&", function () {
      api.rerender('f6a74e80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/VatTemplate.vue"
export default component.exports